export const UPDATE_USER = "UPDATE_USER"
export const UPDATE_LOGIN = "UPDATE_LOGIN"
export const UPDATE_TO_ROUTER = "UPDATE_TO_ROUTER"
export const UPDATE_FROM_ROUTER = "UPDATE_FROM_ROUTER"